<cdk-virtual-scroll-viewport id="virtual-scroll-viewport" itemSize="50" minBufferPx="1000" maxBufferPx="2000">
  <table class="activation-table">
    <thead class="table-header">
      <tr>
        <th class="product-section header" (click)="sortItems()" id="products-header" test-id="product-column-header">
          <div class="product-header-container">
            <div class="icon-container">
              <mat-icon *ngIf="sortIndicator" test-id="sort-order-indicator">
                {{ sortIndicator }}
              </mat-icon>
            </div>
            <div class="header-text-container">
              <span>
                {{ 'APP_SELECTION.ACTIVATION_TABLE.PRODUCT_ADDON_NAME' | translate }}
              </span>
            </div>
          </div>
        </th>
        <th class="quantity-section header">
          <div class="header-text-container">
            <span>{{ 'COMMON.PRICING.QUANTITY' | translate }}</span>
          </div>
        </th>
        <th class="pricing-section header last-column">
          <div class="header-text-container">
            <span *ngIf="!hidePricing" test-id="wholesale-column-header-text">
              {{ 'COMMON.PRICING.WHOLESALE_PRICING' | translate }}
            </span>
          </div>
        </th>
        <th *ngIf="removableItems" class="pricing-section header last-column">
          <div class="header-text-container">
            <span></span>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        [ngClass]="{ 'app-row': item.parentAppId === '' }"
        app-activatable-row
        *cdkVirtualFor="let item of flatItems; trackBy: uniqueActivatableItem; templateCacheSize: 0"
        [activatableItem]="item"
        [hidePricing]="false"
        [quantity]="(selectedItems$ | async)?.get(item.appId)?.quantity || 0"
        [currentlySelectedEditionId]="(selectedItems$ | async)?.get(item.appId)?.editionId"
        [features]="features"
        [removableItems]="removableItems"
        (itemSelectionChanged)="onItemSelectionChanged($event)"
        (itemDeleteClicked)="itemDeleteClicked.emit($event)"
        [indented]="item.parentAppId !== ''"
      ></tr>
    </tbody>
  </table>
</cdk-virtual-scroll-viewport>
